// menuUtils.js

/**
 * Salva lo stato dello scroll attuale prima di navigare al dettaglio prodotto
 */
export const saveScrollState = (selectedCategory, currentScrollLeft) => {
    sessionStorage.setItem("scrollPosition", window.scrollY.toString());
    sessionStorage.setItem("categoryScroll", currentScrollLeft?.toString() || "0");
    sessionStorage.setItem("activeCategory", selectedCategory);
};

/**
 * Gestisce il routing standard verso la scheda prodotto o il configuratore burger
 */
export const handleProductNavigation = (product, productsList, currentIndex, navigate) => {
    if (product.id === "ab568c25-7116-4880-90ab-b0d6295d6f6e") {
        navigate("/crea/hamburger");
    } else {
        navigate(`${product.id}`, {
            state: {
                products: productsList,
                currentIndex,
            },
        });
    }
};